import {
  CHANGE_ZONE,
  CHANGE_ZONE_ERROR,
  CHANGE_ZONE_CLEAN,
  CHANGE_ZONE_CLEAN_ERROR,
} from '_models/redux/types';

const initialState = {
  changeZone: [],
  error: undefined,
  loading: false,
};

export default function changeZoneReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_ZONE:
      return {
        ...state,
        changeZone: action.payload,
        error: undefined,
        loading: false,
      };
    case CHANGE_ZONE_CLEAN:
      return {
        ...state,
        changeZone: [],
        error: undefined,
        loading: false,
      };

    case CHANGE_ZONE_ERROR:
      return {
        ...state,
        changeZone: [],
        error: action.payload,
        loading: false,
      };
    case CHANGE_ZONE_CLEAN_ERROR:
      return {
        ...state,
        error: undefined,
        loading: false,
      };
    default:
      return state;
  }
}
